export function getDeviceType() {
  var x = window.matchMedia("screen and (max-width: 400px)");
  if (x.matches) {
    return "Mobile";
  }
  var y = window.matchMedia(
    "screen and (min-width: 401px) and (max-width: 960px)"
  );
  if (y.matches) {
    return "Tablet";
  }
  var z = window.matchMedia("screen and (min-width: 961px)");
  if (z.matches) {
    return "Desktop";
  }
}
